export default "__VITE_ASSET__qXkyWxHs__"